declare namespace $ {

	export class $easyreels_i18n_switch extends $mol_switch {
		options( ): ({ 
			'ru': string,
			'en': string,
		}) 
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map